import { Component, computed, effect, inject, input } from '@angular/core';
import { DropdownMultiselectItem } from '@bayclubs/drop-down';
import { camps } from '../../../models/models.generated';
import { CampCategory } from '../models/camp-category.model';
import { CampSubcategory } from '../models/camp-subcategory.model';
import { CampCategoryService } from '../services/camp-category.service';
import { CampImagesApiService } from '../services/camp-images-api.service';

@Component({
    selector: 'app-category-image-manager',
    standalone: false,
    templateUrl: './category-image-manager.component.html',
    styleUrl: './category-image-manager.component.scss',
})
export class CategoryImageManagerComponent {
    private categoryService = inject(CampCategoryService);
    private imageService = inject(CampImagesApiService);

    selectedParentCategories = input.required<DropdownMultiselectItem[]>();
    selectedCampTypes = input.required<DropdownMultiselectItem[]>();

    currentTypes = computed(() => {
        const selectedTypes = this.selectedCampTypes();
        const allTypes = this.categoryService.getCampTypes();

        const types = allTypes
            .filter((type) => {
                const isSelected = selectedTypes.some((x) => {
                    const a = x.displayName === type.name;
                    return a;
                });

                return isSelected;
            })
            .sort((a, b) => a.name.localeCompare(b.name));

        return types;
    });

    urls = effect(() => {
        const types = this.currentTypes();
        if (types.length === 0) {
            return;
        }

        const categoriesIds: string[] = types
            .map((types) => {
                const subCategories: string[] = types.campCategories.map((parentCategories) => parentCategories.campSubcategories.map((subCategory) => subCategory.id)).flat();
                const parentCategories: string[] = types.campCategories.map((parentCategory) => parentCategory.id);
                const concatIds: string[] = parentCategories.concat(subCategories);
                return concatIds;
            })
            .flat();

        if (categoriesIds.length === 0) {
            return;
        }

        this.imageService.getCampCategoriesPhotos(categoriesIds, 90, 60).subscribe((x: camps.CampCategoryPhotoUrlModel[]) => {
            const filteredResult = x.filter((photo) => !!photo.photoUrl);
            const categories = types.map((x) => x.campCategories).flat();
            categories.forEach((category) => {
                this.matchPhotoToCategory(category, filteredResult);
                category.campSubcategories.forEach((subcategory) => {
                    this.matchPhotoToCategory(subcategory, filteredResult);
                });
            });
        });
    });

    private matchPhotoToCategory(category: CampCategory | CampSubcategory, photos: camps.CampCategoryPhotoUrlModel[]) {
        const categoryPhotoInfo = photos.find((photo) => photo.campCategoryId === category.id);
        if (categoryPhotoInfo) {
            category.photoUrl.set(categoryPhotoInfo.photoUrl ?? null);
            if ('photoBelongsToParentCategory' in category) {
                (category as CampSubcategory).photoBelongsToParentCategory = categoryPhotoInfo.photoBelongsToParentCategory;
            }
        } else {
            category.photoUrl.set(null);
        }
    }
}
